import { bannerKeys, quotaKeys } from "app/pages/sales-intelligence/modules/quota/utils/i18n";

export type LowCreditsBannerConfigKeys = {
    titleKey: string;
    descriptionKey: string;
    buttonTextKey?: string;
};

export const userLowCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    titleKey: bannerKeys.userTitle,
    descriptionKey: bannerKeys.userDescription,
    buttonTextKey: bannerKeys.userButton,
};

export const adminLowCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    titleKey: bannerKeys.adminTitle,
    descriptionKey: bannerKeys.adminDescription,
    buttonTextKey: bannerKeys.adminButton,
};

export const noTouchLowCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    titleKey: bannerKeys.noTouchTitle,
    descriptionKey: bannerKeys.noTouchDescriptionAddon,
    buttonTextKey: bannerKeys.noTouchButton,
};

export const trialLowCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    titleKey: quotaKeys.needMoreCreditsTitle,
    descriptionKey: quotaKeys.trialNeedMoreCredits,
    buttonTextKey: quotaKeys.upgradeNow,
};

export const INSUFFICIENT_TITLE_KEY = bannerKeys.insufficientTitle;

export const userInsufficientCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    ...userLowCreditsBannerConfigs,
    titleKey: INSUFFICIENT_TITLE_KEY,
};

export const adminInsufficientCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    ...adminLowCreditsBannerConfigs,
    titleKey: INSUFFICIENT_TITLE_KEY,
};

export const noTouchInsufficientCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    ...noTouchLowCreditsBannerConfigs,
    titleKey: bannerKeys.exportMoreCreditsTitle,
};

export const noTouchContactsRevealCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    ...noTouchLowCreditsBannerConfigs,
    titleKey: bannerKeys.revealMoreCreditsTitle,
};

export const trialInsufficientCreditsBannerConfigs: LowCreditsBannerConfigKeys = {
    ...trialLowCreditsBannerConfigs,
    titleKey: quotaKeys.insufficientCreditsTitle,
};
